// Class recipes shared by more than one family: a popover written twice gets its elevation
// changed in one family and missed in the other (packages/ui/docs/nessuna-stringa-qui-dentro.md).

/** A floating panel: surface, border, elevation and the open/close animation. */
export const popoverSurface =
  'z-(--z-popover) overflow-hidden rounded-lg border border-border bg-popover text-popover-foreground shadow-popover data-[state=closed]:animate-out data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95'

/** A row inside such a panel. `cursor-default`: the arrow stays on menu items as on buttons. */
export const menuItemBase =
  'relative flex cursor-default select-none items-center rounded-md text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50'

/** The hairline between groups of rows. */
export const menuSeparator = '-mx-1 my-1 h-px bg-muted'

/** The veil under an overlay (`Dialog`, `Panel`): over the page, under the surface that stands on
 *  it, and fading with it. The ink at 80%; the shell's drawer asks for 60 with `cn`, because at 80
 *  it erased the page (packages/ui/docs/nessuna-stringa-qui-dentro.md). */
export const overlayVeil =
  'fixed inset-0 z-(--z-veil) bg-volee-dark/80 data-[state=closed]:animate-out data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0'

/** A translucent ink pane over any ground. It must sit on an element carrying `data-surface="ink"`. */
export const glassSurface = 'bg-background/60 text-foreground backdrop-blur-md'

/** A hero's band: the ink, with its layers stacked inside and cut at its edge. It must sit on an
 *  element carrying `data-surface="ink"`, like the glass. */
export const inkStage = 'relative overflow-hidden bg-background'

/** The veil a band draws over a picture, darkening to the ink at its foot so the words there
 *  read on any photo. Where it starts is the band's to place: `PlayerHero` veils the lower
 *  half (`inkVeil`), `ClubHero` all of it, since a phone stacks its names up past the middle. */
export const inkFade = 'bg-gradient-to-t from-background via-background/90 to-transparent'

/** The veil over a player's photo: half ink from the middle down, so the face above stays whole and
 *  the name below reads. Lighter than `inkFade` — a portrait is the point of the band. */
export const inkVeil = 'bg-gradient-to-t from-background via-background/50 to-transparent'

/** The veil under a card's names, for a photo that stays whole above them: 70% ink up to two
 *  fifths of the card, gone by three quarters. The names stand in the part that holds. */
export const inkFoot =
  'bg-gradient-to-t from-background via-background/70 via-40% to-transparent to-75%'

/** The option picked among a few shown together — a segment, a design card, the colour being
 *  taken: lime, edged in the text colour and bolder, since lime alone has no edge on the page. */
export const selectedChoice = 'border-foreground bg-primary font-semibold text-primary-foreground'

/** A name or a line from outside that must never push its card wider: it breaks where it has to,
 *  mid-word if need be. */
export const wrapAnywhere = '[overflow-wrap:anywhere]'
